<template>
  <v-dialog
    fullscreen
    hide-overlay
    v-model="opened"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-card tile>
      <v-card-title class="modal__title px-4 pt-4 pb-4">
        <span class="primary--text">
          Atualizar Cidade
        </span>
        <v-spacer />
        <v-btn @click="opened = false" color="primary" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5 white text-body-1">
        <v-form class="mw-700 py-5 mx-auto" ref="cityForm">
          <v-row class="mb-6">
            <v-col>
              <h3 class="mb-3">
                {{ $t('city.label.status') }}
              </h3>

              <div class="mb-3">
                <span class="text-subtitle-1 font-weight-light">
                  {{
                    `A cidade está ${city.enabled ? 'ativada' : 'desabilitada'}`
                  }}
                </span>
              </div>

              <div>
                <v-btn
                  @click="updateStatus()"
                  :loading="isLoading"
                  class="primary"
                >
                  {{ !city.enabled ? 'Ativar' : 'Desabilitar' }}
                </v-btn>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <CityServices
                v-model="selectedServices"
                :on-update="updateServiceTypes"
                :loading="isLoading"
                :service-button-rules="serviceButtonRules"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import HTextInput from '@/components/app/HTextInput'
import HCheckbox from '@/components/app/HCheckbox'
import HAutocomplete from '@/components/app/HAutocomplete'
import CityServices from '@/components/city/CityServices'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'CityUpdate',

  components: {
    HTextInput,
    HCheckbox,
    HAutocomplete,
    CityServices,
  },

  data() {
    return {
      opened: false,
      confirmStatusAction: false,
      selectedServices: [],
      servicesToAdd: [],
      servicesToRemove: [],
    }
  },

  watch: {
    selectedServices(old, newValue) {
      this.handleAddedAndRemovedServices()
    },
  },

  computed: {
    ...mapGetters(['isLoading', 'city']),

    serviceButtonRules() {
      return (
        this.isLoading ||
        (this.servicesToAdd.length <= 0 && this.servicesToRemove.length <= 0)
      )
    },
  },

  methods: {
    ...mapActions([
      'fetchCitiesPaginated',
      'fetchCity',
      'updateCityStatus',
      'showSuccessMessage',
      'showErrorMessage',
      'updateCityServiceTypes',
    ]),

    ...mapMutations(['setIsLoading']),

    updateStatus() {
      this.setIsLoading(true)

      this.updateCityStatus(this.city.id)
        .then(async () => {
          this.showSuccessMessage('Status atualizado com sucesso!')
          await this.fetchCity(this.city.id)
          await this.fetchCitiesPaginated()
        })
        .catch(({ data }) => {
          data?.errors && data?.errors?.length >= 1
            ? this.showErrorMessage(data.errors[0].message)
            : this.showErrorMessage(data.message)
        })
        .finally(() => {
          this.setIsLoading(false)
        })
    },

    updateServiceTypes() {
      this.setIsLoading(true)

      const body = {
        city_id: this.city.id,
        services_to_add: this.servicesToAdd,
        services_to_remove: this.servicesToRemove,
      }

      this.updateCityServiceTypes(body)
        .then(async () => {
          this.showSuccessMessage('Serviços atualizado com sucesso!')
          await this.fetchCity(this.city.id)
          await this.fetchCitiesPaginated()
        })
        .catch(({ data }) => {
          data?.errors && data?.errors?.length >= 1
            ? this.showErrorMessage(data.errors[0].message)
            : this.showErrorMessage(data.message)
        })
        .finally(() => {
          this.setIsLoading(false)
          this.servicesToAdd = []
          this.servicesToRemove = []
        })
    },

    handleAddedAndRemovedServices() {
      this.servicesToAdd = this.selectedServices

      this.city.services.forEach((service) => {
        if (!this.selectedServices.includes(service)) {
          if (!this.servicesToRemove.includes(service)) {
            this.servicesToRemove.push(service)
          }
        } else {
          if (this.servicesToRemove.includes(service)) {
            this.servicesToRemove = this.servicesToRemove.filter(
              (s) => s != service
            )
          }
          this.servicesToAdd = this.servicesToAdd.filter((s) => s != service)
        }
      })
    },

    async openModal(id) {
      await this.fetchCity(id)
      this.selectedServices = this.city.services
      this.opened = true
    },
  },
}
</script>
